import React from "react";
import T from "prop-types";
import { Col, Row } from "react-bootstrap";
import DetailStat from "../DetailStat";
import { dollar } from "../format";

export default function Detail({ stats }) {
  return (
    <Row>
      <Col md={3} sm={3}>
        &nbsp;
      </Col>
      <DetailStat
        label="<12 mos"
        value={dollar(stats.total_cost_0_to_12_months_dollars)}
      />
      <DetailStat
        label="12 to 18 mos"
        value={dollar(stats.total_cost_12_to_18_months_dollars)}
      />
      <DetailStat
        label=">18 mos"
        value={dollar(stats.total_cost_18_to_INF_months_dollars)}
      />
      <Col md={3} sm={3}>
        &nbsp;
      </Col>
    </Row>
  );
}

Detail.propTypes = {
  stats: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/StatsTooltip/InventoryStats/Detail.jsx